<ng-container *ngIf="isIcon">
    <ng-container [ngSwitch]="piiShieldLevel">
        <img *ngSwitchCase="PII_LEVEL.one" src="{{PII_SHIELD_LEVEL_BADGES_SOURCES_MAP.icon1}}" mat-card-image alt="Level 1"
             class="pii-badge" [ngClass]="{'extra-small': extraSmall, 'small': small, 'medium': medium, 'large': large}"
        >
        <img *ngSwitchCase="PII_LEVEL.two" src="{{PII_SHIELD_LEVEL_BADGES_SOURCES_MAP.icon2}}" mat-card-image alt="Level 2"
             class="pii-badge" [ngClass]="{'extra-small': extraSmall, 'small': small, 'medium': medium, 'large': large}"
        >
        <img *ngSwitchCase="PII_LEVEL.three" src="{{PII_SHIELD_LEVEL_BADGES_SOURCES_MAP.icon3}}" mat-card-image alt="Level 3"
             class="pii-badge" [ngClass]="{'extra-small': extraSmall, 'small': small, 'medium': medium, 'large': large}"
        >
    </ng-container>
</ng-container>
<ng-container *ngIf="!isIcon">
    <ng-container [ngSwitch]="piiShieldLevel">
        <img *ngSwitchCase="PII_LEVEL.one" src="{{PII_SHIELD_LEVEL_BADGES_SOURCES_MAP.image1}}" mat-card-image alt="Level 1"
             class="pii-badge" [ngClass]="{'extra-small': extraSmall, 'small': small, 'medium': medium, 'large': large}"
        >
        <img *ngSwitchCase="PII_LEVEL.two" src="{{PII_SHIELD_LEVEL_BADGES_SOURCES_MAP.image2}}" mat-card-image alt="Level 2"
             class="pii-badge" [ngClass]="{'extra-small': extraSmall, 'small': small, 'medium': medium, 'large': large}"
        >
        <img *ngSwitchCase="PII_LEVEL.three" src="{{PII_SHIELD_LEVEL_BADGES_SOURCES_MAP.image3}}" mat-card-image alt="Level 3"
             class="pii-badge" [ngClass]="{'extra-small': extraSmall, 'small': small, 'medium': medium, 'large': large}"
        >
    </ng-container>
</ng-container>
